module.exports = __webpack_public_path__ + "img/grid.0f9c1edd.svg";